import React, { useEffect, useState } from 'react'
import { ScrollView, Text, View } from 'react-native'
import { getMediaStreaming } from '../../../Redux/Actions/tvRemoteAction';
import TVRemote_Landscape from './TVRemote_landscape';
import { useCssStyle } from '../../../customHook/getCssStyle';
import CustomPressable from '../../../components/customPressable/customPressable';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import HeaderWithBack from '../../../components/Header/headerWithBack';
import { ImageComp } from '../../../components/Image/Image';
import { getCleanUrl } from '../../../utils/Helper';
import Loader from '../../../components/Loader/loader';
import { TV } from '../../../assets';
import TVChannels_Landscape from './TVChannels_landscape';

const Remote_Landscape = (props) => {
  const { loading, initialiseRemote, handleRefreshToken, sendCommand, clickChannel, handleMedialStreaming } = props;

  const getStyles = useCssStyle();
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const { currentWidget } = useSelector((state) => state.deviceConfigSlice);
  const { isRoomRemoteLoading, isChannelDataLoading, isMediaListLoading, currentTv, roomRemoteDetails, mediaList } = useSelector(state => state.tvRemoteSlice);

  const [currentPage, setCurrentPage] = useState(0);

  useEffect(()=> {
    if(currentTv?.deviceType === "APPLETV") {
      setCurrentPage(0);
    }

  }, [currentTv?.deviceType])

  

  return (
    <View style={getStyles(['widgetRootContainer', 'tvRemoteRootContainer_landscape'])} id='tvRemoteRootContainer_landscape'>
      <HeaderWithBack />

      <View style={getStyles(['widgetmainContainerHeaderContainer', 'tvRemoteHeaderContainer_landscape'])} id='tvRemoteHeaderContainer_landscape'>
        {
          currentWidget?.widgetHeaderImageUrl && 
            <ImageComp
                source={getCleanUrl(currentWidget?.widgetHeaderImageUrl)} 
                style={getStyles(['widgetmainContainerHeaderImg', 'tvRemoteHeaderImg_landscape'])} id={"tvRemoteHeaderImg_landscape"}
            />
        }
        <View style={getStyles(['widgetmainContainerHeaderTitleContainer', 'tvRemoteHeaderTitleContainer_landscape'])} id='tvRemoteHeaderTitleContainer_landscape'>
          <Text style={getStyles(['widgetmainContainerHeaderTitle', 'tvRemoteHeaderTitle_landscape'])} id='tvRemoteHeaderTitle_landscape'>
            {t("room_control.tv_control.header")}
          </Text>
        </View>

      </View>
      <View style={getStyles(["tvRemoteFilterPillContainer"])} id="tvRemoteFilterPillContainer">
        <ScrollView horizontal showsHorizontalScrollIndicator={false} contentContainerStyle={getStyles(['tvRemoteFilterContainer'])} id="tvRemoteFilterContainer" style={{ width: '100%' }}>
          {[
            t('room_control.tv_control.remote_btn'), 
            t('room_control.tv_control.guide_btn')
          ].map((iterator, index) => (
            <CustomPressable 
              key={index} 
              onPress={() => setCurrentPage(index)} 
              style={getStyles(['tvRemoteFooterButtonItemContainer_landscape', currentPage == index && 'tvRemoteFooterActiveContainer_landscape'])} 
              id={`tvRemoteFooterButtonItemContainer_landscape tvRemoteFooterActiveContainer_landscape`}
              disabled={!roomRemoteDetails?.length}
            >
              <Text 
                style={getStyles(['tvRemoteFooterButton_landscape', currentPage == index && 'tvRemoteFooterActiveButton_landscape'])} 
                id={`tvRemoteFooterButton_landscape tvRemoteFooterActiveButton_landscape`}
              >
                {iterator}
              </Text>
            </CustomPressable>
          ))}
        </ScrollView>
      </View>

      <ScrollView
        automaticallyAdjustKeyboardInsets={true} 
        contentContainerStyle={getStyles(['widgetmainContainer', 'tvRemoteMainContainer_landscape'])} 
        showsVerticalScrollIndicator={false}
        id='tvRemoteMainContainer_landscape'
      >

        <View style={getStyles(['widgetmainContainerChildContainer', 'tvRemoteContainerChildContainer_landscape'])} id='tvRemoteContainerChildContainer_landscape'>

          {currentPage===0 && <View style={getStyles(["mediaTvHeaderContainer"])} id='mediaTvHeaderContainer'>
            <Text style={getStyles(["mediaTvHeaderContainerTitle"])} id='mediaTvHeaderContainerTitle' >{t("tv_remote.media_streaming")}</Text>
          </View>}

          {currentPage===0 && <View style={getStyles(["mediaDeviceListMainContainer"])} id='mediaDeviceListMainContainer'>
            {
              isMediaListLoading ? 
                <View style={getStyles(['mediaDeviceListContainer_loader'])}>
                  <Loader size={'small'} style={getStyles(['mediaDeviceList_loader'])}/> 
                </View>

              : mediaList?.length < 1 && roomRemoteDetails?.length ? <CustomPressable onPress={() => dispatch(getMediaStreaming())} style={getStyles(['primaryBtn'])}>
                  <Text style={getStyles(['primaryBtnTxt'])}>{
                    t("room_control.tv_control.media_not_available")
                  }</Text>
                </CustomPressable>
              : <>
                
                  {mediaList?.map((iterator, index) => {
                    return <CustomPressable style={getStyles(["mediaDeviceListContainer"])} onPress={() => handleMedialStreaming([iterator?.mediaName])} id="mediaDeviceListContainer">
                      {iterator?.imageUri ? <ImageComp source={getCleanUrl(iterator?.imageUri)} style={getStyles(["mediaDeviceImageContainer"])} id="mediaDeviceImageContainer" /> : <Text style={getStyles(["mediaDeviceText"])} id='mediaDeviceText'>TV {index+1}</Text>}

                      <View style={getStyles(["mediaDeviceTextContainer"])} id='mediaDeviceTextContainer'>
                        <Text style={getStyles(["mediaDeviceText"])} id='mediaDeviceText'>
                          {iterator?.mediaName}
                        </Text>
                      </View>

                    </CustomPressable>})}
                  </>
                }

              {!roomRemoteDetails?.length && !loading && <View style={getStyles(['tvRemoteFallbackContainer_landscape'])} id='tvRemoteFallbackContainer_landscape'>
                    <ImageComp
                        source={TV}
                        style={getStyles(["tvRemoteFallbackImage_landscape"])} 
                        id='tvRemoteFallbackImage_landscape'
                    />

                    <CustomPressable onPress={handleRefreshToken} style={getStyles(['primaryBtn'])} id='primaryBtn'>
                        <Text style={getStyles(['primaryBtnTxt'])} id='primaryBtnTxt'>No TV is connected, retry?</Text>
                    </CustomPressable>
                </View>}
          </View>
          }
          {currentPage===1 && <TVChannels_Landscape clickChannel={clickChannel} {...props} />}

        </View>
        
        
      </ScrollView>
      {roomRemoteDetails?.length && <TVRemote_Landscape initialiseRemote={initialiseRemote} sendCommand={sendCommand} />}

    </View>
  )
}

export default Remote_Landscape
